import React from 'react';

import Spinner from 'Shared/components/Spinner';

import { SyncMeetingsModalButtons } from '../types';

type Props = {
  primaryButtonType: SyncMeetingsModalButtons;
  disabledSubmit: boolean;
  isSubmitting: boolean;
  onCancleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onPrimaryClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

function SyncMeetingsModalButtonsArea({ onPrimaryClick, disabledSubmit, isSubmitting, primaryButtonType }: Props) {
  return (
    <>
      <button
        type="button"
        className={`btn ${
          primaryButtonType === SyncMeetingsModalButtons.SKIP ? 'btn-outline-primary' : 'btn-primary'
        } sync-meetings-modal-button px-4 py-1 float-right`}
        onClick={onPrimaryClick}
        disabled={disabledSubmit}
      >
        {primaryButtonType}
        <div>
          <Spinner
            activeIf={isSubmitting}
            color="#fff"
            spinnerStyles={{ width: '.8rem', height: '.8rem', borderWidth: '.1rem', marginLeft: '.5rem' }}
          />
        </div>
      </button>
    </>
  );
}

export default SyncMeetingsModalButtonsArea;
